import {
  GuardTourOrderField,
  OrderDirection,
} from '@/graphql/generated/schemas'

const orderByMapping: Record<string, GuardTourOrderField> = {
  submittedTime: GuardTourOrderField.UpdatedAt,
}

export const getOrderBy = (
  column: string | null,
  order: 'asc' | 'desc' | null
): { direction: OrderDirection; field: GuardTourOrderField }[] => {
  const field = column ? orderByMapping[column] : undefined
  if (!field || !order) {
    return [
      {
        direction: OrderDirection.Desc,
        field: GuardTourOrderField.UpdatedAt,
      },
    ]
  }
  return [
    {
      direction: order === 'desc' ? OrderDirection.Desc : OrderDirection.Asc,
      field,
    },
  ]
}
